import React from 'react';
import { Lock } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { MODULE_LABELS } from '@/utils/storeModules';
import { useModules } from '../../context/ModuleContext';

/**
 * Banner shown at the top of a module's pages once that platform is switched
 * off. Renders nothing while the module is live, so pages can mount it
 * unconditionally.
 *
 * Pair it with `readOnly` on the page's own controls — the banner explains the
 * state, it does not enforce it.
 */
export default function ModuleReadOnlyNotice({ module }) {
    const { isReadOnly } = useModules();
    if (!isReadOnly(module)) return null;

    const label = MODULE_LABELS[module] || module;
    return (
        <Alert className="mb-6 border-amber-200 bg-amber-50 text-amber-900">
            <Lock className="h-4 w-4 !text-amber-600" />
            <AlertTitle>{label} is turned off</AlertTitle>
            <AlertDescription className="text-amber-800">
                Your existing records stay available to view, but nothing here can be changed.
                Contact your administrator to turn {label} back on.
            </AlertDescription>
        </Alert>
    );
}
